<template>
  <div>
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewSettings.widget.title") }}</h3>
    <v-card class="mt-2" elevation="0">
      <v-card-text>
        {{ $t("viewSettings.widget.code_def") }}
        <v-text-field
          v-model="code"
          ref="textToCopy"
          outlined
          hide-details
          :disabled="isDisabled"
        ></v-text-field>
        <v-btn @click="copyText" class="mt-2" color="primary" elevation="0">
          <v-icon left small>fa-clipboard</v-icon>
          {{ $t("common.copy") }}</v-btn
        >
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  data: () => ({
    code: "",
    isDisabled: true,
  }),
  created() {
    let url = process.env.VUE_APP_BIDS_WIDGET_REQUEST_LOADER_URL;
    this.code =
      `<script id="levam_platfrom_widget"` +
      ` src="${url}"`+
      ` wg-code="${this.authenticatedUser.shop.wg_code}"`+
      ` wg-type="additional"`+
      ` wg-lang="${this.lang}"`+
      ` async><`+"/script>";
  },
  computed: {
    ...mapFields("auth", ["authenticatedUser"]),
    ...mapFields("site", ["lang"]),
  },
  watch: {},
  methods: {
    copyText() {
      this.isDisabled = false;
      this.$nextTick(() => {
        let textToCopy = this.$refs.textToCopy.$el.querySelector("input");
        textToCopy.select();
        document.execCommand("copy");
        this.isDisabled = true;
      });
    },
  },
};
</script>

<style scoped></style>
